var linkBg = "/static/15aa3057d0d32339.webp";

export { linkBg as default };
//# sourceMappingURL=shadow.webp.js.map
